import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-save-icon',
  templateUrl: 'save-icon.component.html'
})
export class SaveIconComponent {
  constructor() {}
}
